import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import RoutesConstants from '../../../@commons/constants/routes.constants';
import { BellIconComponent } from '../../../@icons/bell-icon.component';
import { VwDatePipe } from '../../../@commons/pipes/vw-date.pipe';
import { AlertsStore } from '../../../@commons/@services/data/alerts.store';

/**
 * L'en-tête de l'accueil (`vw-header-home`) : une ligne de 44 px, la date et
 * la cloche. Le prénom ne dit rien du jardin ; la cloche garde son nom pour
 * le lecteur d'écran, avec le nombre d'alertes à lire. Un invité voit
 * « Se connecter » à la place de la cloche.
 */
@Component({
  selector: 'vw-header-home',
  imports: [TranslatePipe, BellIconComponent, VwDatePipe],
  templateUrl: './header-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HeaderHomeComponent implements OnInit {
  /** Le jour affiché ; aujourd'hui par défaut. */
  @Input() date: Date = new Date();
  /** Invité : « Se connecter » à la place de la cloche. */
  @Input() guest = false;

  private readonly router = inject(Router);
  private readonly alerts = inject(AlertsStore);
  /** Le compteur de la cloche, partagé avec le reste de l'app. */
  readonly unreadCount = this.alerts.unreadCount;

  async ngOnInit() {
    await this.alerts.refreshCount();
  }

  handleSignin() {
    this.router.navigate([RoutesConstants.LOGIN]);
  }

  handleBell() {
    this.router.navigate([RoutesConstants.NOTIFICATIONS]);
  }
}
